import { render, staticRenderFns } from "./item-add.vue?vue&type=template&id=4e1aa536&scoped=true&"
import script from "./item-add.vue?vue&type=script&lang=js&"
export * from "./item-add.vue?vue&type=script&lang=js&"
import style0 from "./item-add.vue?vue&type=style&index=0&id=4e1aa536&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1aa536",
  null
  
)

export default component.exports